import { createContext, useContext } from "react";

interface IContext {
  params:any;
  onChangeParams: (newParams:any) => void;
}

export const Context = createContext<IContext | undefined>(undefined);

const useCasesContext = ():IContext => {
  const context = useContext(Context);
  if ( !context ) throw new Error('useCasesContext must be used within a CasesProvider');
  return context;
}

export default useCasesContext;
